import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { View, App } from '@gin-betting/core';

import { getScoreTitle } from 'utils';
import globalMessages from 'messages';
import useScore from './useScore';
import './Score.scss';
import { MatchPartInfo } from 'types';

interface OwnProps {
    isEnded?: boolean;
    numberOfShowed: number;
    hasMatchHeader?: boolean;
    sportId: string;
    matchId: string;
}

const Score: React.FC<OwnProps> = ({
    isEnded,
    hasMatchHeader,
    numberOfShowed,
    sportId,
    matchId,
}) => {
    const {
        extra,
        showed,
        isServerKnown,
        isHomeServer,
        isAwayServer,
        winner,
        isExtendable,
        isFullView,
        toggleView,
        currentMatchPart,
    } = useScore({ matchId, sportId, isEnded, numberOfShowed });

    const scoresFullLength = showed.length + extra.length;

    return (
        <div
            styleName={cn('container', {
                [`winner-${winner}`]: !!winner,
                'is-open': isFullView,
                'is-short-view': !isExtendable,
                'is-long': scoresFullLength > 8,
            })}
            className="__app-Score2-container"
        >
            {hasMatchHeader && (
                <div styleName="name" className="__app-Score2-name">
                    <FormattedMessage {...globalMessages.score} />
                </div>
            )}
            <div styleName="dynamic-scores-wrapper">
                <div
                    styleName={cn('dynamic-scores', {
                        'with-server': isServerKnown,
                    })}
                >
                    {isExtendable && (
                        <div styleName="toggle-wrapper" onClick={toggleView}>
                            <div styleName="toggle-btn" />
                        </div>
                    )}
                    {isServerKnown && (
                        <div styleName="score-server">
                            <div
                                styleName={cn('server', {
                                    active: isHomeServer,
                                })}
                            />
                            <div
                                styleName={cn('server', {
                                    active: isAwayServer,
                                })}
                            />
                        </div>
                    )}
                    {extra.map(score => (
                        <ScoreItem
                            key={score.type + score.indexNumber}
                            score={score}
                            currentMatchPart={currentMatchPart}
                        />
                    ))}
                </div>
            </div>
            <div styleName="constant-scores-wrapper ">
                {showed.map(score => (
                    <ScoreItem
                        key={score.type + score.indexNumber}
                        score={score}
                        currentMatchPart={currentMatchPart}
                    />
                ))}
            </div>
        </div>
    );
};

const ScoreItem: React.FC<{
    score: View.ScoreInfo;
    currentMatchPart: MatchPartInfo | null;
}> = ({ score, currentMatchPart }) => {
    const name = getScoreTitle(score, currentMatchPart);

    const isTotal = score.type === App.ScoreTypes.TYPE_TOTAL;

    return (
        <div
            styleName={cn('score', {
                total: isTotal,
            })}
        >
            <div styleName="home">{score.home}</div>
            <div styleName="score-title ">{name}</div>
            <div styleName="away">{score.away}</div>
        </div>
    );
};

export default Score;
